import { useInfiniteQuery } from 'react-query'
import { getMonyPoolsDetailLoans } from 'services/fund'

export default function useGetLoans(
    id: string | undefined,
    searchLoans: string
) {
    const { data, isLoading, fetchNextPage, isError } = useInfiniteQuery(
        ['money-pools-fund-loans-infinite-loans', id, searchLoans],
        ({ pageParam = 1, queryKey }) =>
            getMonyPoolsDetailLoans(pageParam, queryKey[1], searchLoans),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('page')
                    : undefined
            },
        }
    )
    return { data, isLoading, fetchNextPage, isError }
}
